import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Header from "./Components/Header";
import BtmButton from "./Components/BtmButton";
import axios from '../../api/axios';
import axios_real, { AxiosError } from "axios";
import FullscreenLoading from "./Components/FullScreenLoader";
import { FaCapsules } from "react-icons/fa";
import PaymentMethods from "./Components/PaymentMethod";
import { FiCopy } from 'react-icons/fi';
import { sendMessageToReactNativeApp } from "../../components/utils/sendMessageToReactNativeApp";
import { decryptFromBackend } from "../../utils/urlDecryptor";

export type HospitalAddOn = {
  id: number;
  hospital_id: number;
  key: string;
  value: string | number;
};


const CheckOutPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const {prescriptionId, token} = useParams<{prescriptionId: string, token: string}>();

    const decryptedToken = useMemo(() => {
        if (!token) return '';
        try {
          return decryptFromBackend(token);
        } catch (err) {
          console.error('Failed to decrypt token:', err);
          return '';
        }
    }, [token]);

    // User data start
    const storedData = sessionStorage.getItem('userData');
    const userDataDefault = storedData ? JSON.parse(storedData) : {};
    const [userData, setUserData] = useState(userDataDefault);
    // const token = userData?.token || '';
    // User data end
    // const queryparams = new URLSearchParams(location.search);
    // const prescriptionId = queryparams.get('prescriptionid');
    const [showPharmacyAlert, setShowPharmacyAlert] = useState(false);
    const [showShippingModal, setShowShippingModal] = React.useState(false);
    const [prescriptionData, setPrescriptionData] = useState<any>(null);
    const [prescriptionCode, setPrescriptionCode] = useState<any>(null);
    const [practitionerId, setPractitionerId] = useState<any>(null);

    const getPrescriptionDatas = () => {
        axios
            .get(`prescription/get-prescription-datas/${prescriptionId}`,{
                headers: {
                    Authorization: `Bearer ${decryptedToken}`,
                },
            })
            .then((response) => {
                setPrescriptionData(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Gagal mengambil resep', error);
                // navigate('/not-found')
                setLoading(false);
            })
    }
    const hasFetched = useRef(false);
    useEffect(()=>{
        if (!prescriptionId) {
            navigate('/not-found');
            return;
        }
        if(prescriptionId && !hasFetched.current)
        {
            setLoading(true);
            getPrescriptionDatas();
            getPaymentMethods();
            hasFetched.current = true;
        }
    }, [prescriptionId]);
    useEffect(() => {
        if(prescriptionData && !prescriptionData?.order?.lat)
        {
            navigate(`/e-prescription/address-page/${prescriptionId}/${token}`,{
                state: {
                    addressState:prescriptionData?.order?.recipient_address,
                    nameState: prescriptionData?.order?.recipient_name ? prescriptionData?.order?.recipient_name : prescriptionData?.patient?.name,
                    phoneState: prescriptionData?.order?.recipient_phone ? prescriptionData?.order?.recipient_phone : prescriptionData?.patient?.phone,
                    noteState: prescriptionData?.order?.recipient_note,
                    latState: prescriptionData?.order?.lat,
                    lngState: prescriptionData?.order?.lng
                }
            });
        }
    }, [prescriptionData]);
    const handleOpenAddressPage = () => {
        navigate(`/e-prescription/address-page/${prescriptionId}/${token}`,{
            state: {
                addressState:prescriptionData?.order?.recipient_address,
                nameState: prescriptionData?.patient?.name ? prescriptionData?.patient?.name : prescriptionData?.order?.recipient_name,
                phoneState: prescriptionData?.order?.recipient_phone ? prescriptionData?.order?.recipient_phone : prescriptionData?.patient?.phone,
                noteState: prescriptionData?.order?.recipient_note,
                latState: prescriptionData?.order?.lat,
                lngState: prescriptionData?.order?.lng
            }
        });
    };
    const {
        addressState,
        nameState,
        phoneState,
        noteState,
        latState,
        lngState
    } = location.state || {};
    //shipping
    const shippingOptions = prescriptionData?.pharmacy?.shipping ?? [];
    const defaultShippingOption = useMemo(() => {
        if (!shippingOptions || shippingOptions.length === 0) return null;

        const instant = shippingOptions.find(
            (opt: any) => opt.shipping_method?.toUpperCase() === "INSTANT"
        );
        if (instant) return instant;

        const reguler = shippingOptions.find(
            (opt: any) => opt.shipping_method?.toUpperCase() === "REGULER"
        );
        if (reguler) return reguler;

        return shippingOptions[0];
    }, [shippingOptions]);
    const [outletId, setOutletId] = useState(null);
    const [outlet, setOutlet] = useState('');
    const [shippingCost, setShippingCost] = useState(0);
    const [feeService, setFeeService] = useState(0);
    const [shippingMethod, setShippingMethod] = useState('');
    const [drugPrice, setDrugPrice] = useState(0);
    const [cost, setCost] = useState(0);
    const [shippingDiscount, setShippingDiscount] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>(null);
    const [baseShippingDiscount, setBaseShippingDiscount] = useState(0);
    const [redirecting, setRedirecting] = useState(false);
    useEffect(() => {
    if (prescriptionData?.practitioner?.hospital_id) {
        const hospitalId = prescriptionData.practitioner.hospital_id;
        axios
        .get(`/hospital-add-ons?organization_id=${hospitalId}`, {
                headers: {
                    Authorization: `Bearer ${decryptedToken}`,
                },
            })
        .then((res) => {
            if (res.data?.data) {
                const addons: HospitalAddOn[] = res.data.data;
                const discount = addons.find((item) => item.key === 'price_shipping_discount');
                const discountValue = parseInt(discount?.value?.toString() || '0');
                setBaseShippingDiscount(discountValue);
                setShippingDiscount(discountValue);
            }
        })
        .catch(() => {
            setBaseShippingDiscount(0);
            setShippingDiscount(0);
        });
    }
    }, [prescriptionData]);

    useEffect(() => {
        if(defaultShippingOption)
        {
            setOutletId(prescriptionData?.pharmacy?.outlets?.outlet_id);
            setOutlet(prescriptionData?.pharmacy?.outlets?.outlet);
            setShippingCost(defaultShippingOption?.shipping_cost);
            setFeeService(Number(defaultShippingOption?.fee_service));
            setShippingMethod(defaultShippingOption?.shipping_method);
            //set Prescription Code
            setPrescriptionCode(prescriptionData?.prescription?.prescription_code);
            setPractitionerId(prescriptionData?.prescription?.practitioner_id);
        }   
    }, [defaultShippingOption]); 
    useEffect(() => {
        setDrugPrice(0);//ditanggung
        setCost(feeService+shippingCost);
    },[shippingCost, feeService]);
    useEffect(() => {
        setTotalPrice(Math.max(0, cost + drugPrice - shippingDiscount));
    }, [cost, drugPrice, shippingDiscount]);
    //get payment method
    const [paymentMethod, setPaymentMethod] = useState([]);
    const [selectedPaymentpaymentId, setSelectedPaymentpaymentId] = useState<number | null>(null);
    const handlePaymentSelect = (paymentId: number, paymentMethodData: any) => {
        setSelectedPaymentpaymentId(paymentId);
        setSelectedPaymentMethod(paymentMethodData);
        
        const virtualAccountCodes = ['VA', 'I1', 'BT', 'B1', 'M2', 'BR', 'BC', 'AG', 'S1', 'A1', 'NC'];
        const eWalletCodes = ['OV', 'LA', 'SA', 'DA'];

        const code = paymentMethodData?.code?.toUpperCase() || '';

        const isVirtualAccount = virtualAccountCodes.includes(code);
        const isEwallet = eWalletCodes.includes(code);

        const currentCost = feeService + shippingCost;
        const minTotal = 10000;
        let newDiscount = baseShippingDiscount;

        if (isVirtualAccount || isEwallet) {
            const currentTotal = currentCost - newDiscount;
            if (currentTotal < minTotal) {
                const adjustment = minTotal - currentTotal;
                newDiscount = Math.max(0, baseShippingDiscount - adjustment);
            }
        }

        setShippingDiscount(newDiscount);
    };

    const getPaymentMethods = () => {
        axios
            .get(`payment?configuration=category_payment_live_consultation`,{
                headers: {
                    Authorization: `Bearer ${decryptedToken}`,
                },
            })
            .then((response)=>{
                setPaymentMethod(response.data.data);
            })
            .catch((error)=>{
                console.log(error)
            })
    };
    //chcek form
    const formReady = prescriptionId && outletId && shippingMethod && selectedPaymentpaymentId && totalPrice;
    const handleConfirmation = async () => {
        if (loading) return;
        try {
            setLoading(true);
            const response = await axios.post(`prescription/create-prescription-order`, {
                prescription_id : prescriptionId,
                prescription_code: prescriptionCode,
                practitioner_id: practitionerId,
                outlet_id: outletId,
                outlet: outlet,
                shipping_method: shippingMethod,
                shipping_cost:shippingCost,
                fee_service: feeService,
                total_price: totalPrice,
                payment_method_id: selectedPaymentpaymentId
            }, {
            headers: {
                Authorization: `Bearer ${decryptedToken}`,
            }
            });

            const res = response.data;

            if (res.status === 'success' && res.data?.payment?.statusMessage === 'SUCCESS') {
                setShippingDiscount(res.data.adjusted_discount || shippingDiscount);
                setTotalPrice(res.data.final_total || totalPrice);
                const paymentLink = res.data.payment.paymentUrl;
                if (paymentLink) {
                    window.location.href = paymentLink;
                } else {
                    console.error('Link pembayaran tidak tersedia.');
                }
            } else {
                console.error('Gagal membuat pembayaran:', res);
            }
            setLoading(false);
            
        } catch (error) {
            console.error('Error fetching data:', error);
            if (axios_real.isAxiosError(error)) {
                const status = error.response?.status;
                const msg =
                    (error.response?.data as any)?.message ||
                    "Terjadi kesalahan saat membuat pesanan.";
    
                if (status === 400 || status === 422) {
                    if(msg == 'is_redeemed')
                    {
                        window.location.reload();
                    }
                }
            }
            setLoading(false);
        }
    }
    const [showPaymentModal, setShowPaymentModal] = useState<boolean>(false);
    useEffect(() => {
        const status = prescriptionData?.transaction?.status_payment;
        if (status === 'draft' || status === 'payment') {
            setShowPaymentModal(true);
        }
    }, [prescriptionData]);

    const [showRedeemInfoModal, setShowRedeemInfoModal] = useState<boolean>(false);

    useEffect(() => {
        // Jika resep sudah ditebus/download
        if (prescriptionData?.prescription?.is_download) {
            setShowRedeemInfoModal(true);
        }
    }, [prescriptionData]);


    const handleCloseDialog = () => {
        sendMessageToReactNativeApp({ action:'UNIFIED_TELEMEDICINE_DETAIL_MEDICINE',data: {orderId: prescriptionData.prescription?.prescription_code } });
    }

    const handleLanjutPembayaran = async () => {
        try {
            setRedirecting(true);
            // Ambil data terbaru dulu biar valid
            const response = await axios.get(
                `prescription/get-prescription-datas/${prescriptionId}`,
                {
                    headers: { Authorization: `Bearer ${decryptedToken}` },
                }
            );
    
            const newData = response.data;
            setPrescriptionData(newData);
            const isRedeem = newData?.prescription?.is_download;
            const trx = newData?.transaction;
    
            // Jika sudah dibayar atau sudah diredeem, reload halaman
            if (!isRedeem) {
                if (trx?.url_payment) {
                    // Kalau belum dibayar → lanjut ke halaman pembayaran
                    window.location.href = trx.url_payment;
                }
            }
        } catch (error) {
            console.error('Gagal cek status pembayaran:', error);
        } finally {
            setRedirecting(false)
        }
    };
    
    return (
        <div className="min-h-screen bg-white pb-20">
            {loading && <FullscreenLoading message="Mohon tunggu..."/>}
            <Header title="Checkout" />
            <div className="p-4 space-y-3 bg-gray-100">

                {/* Alamat Card */}
                <div className="relative bg-white p-4 rounded-xl shadow-sm border">
                    <p className="text-sm text-gray-500 mb-1">Alamat</p>
                    <p className="font-semibold text-sm">{prescriptionData?.order?.recipient_address}</p>
                    <p className="text-sm text-gray-700">{prescriptionData?.order?.recipient_note}</p>
                    <p className="text-sm text-gray-500">{prescriptionData?.order?.recipient_name} • {prescriptionData?.order?.recipient_phone}</p>
                    <button className="absolute top-4 right-4 text-gray-500"
                        onClick={handleOpenAddressPage}
                    >
                        <img
                            src="/images/pencil-simple.svg"
                            alt="Edit Alamat"
                            className="w-4 h-4"
                        />
                    </button>
                </div>

                {/* Dokter Card */}
                <div className="bg-white p-4 rounded-xl shadow-sm border">
                    <p className="font-semibold text-sm">{prescriptionData?.practitioner?.dr_name}</p>
                    <p className="text-sm text-gray-500">{prescriptionData?.practitioner?.hospital}</p>
                    <p className="text-sm text-gray-700 border-t pt-1 mt-1">
                        {prescriptionData?.patient?.name} ({prescriptionData?.patient?.birth_date} y.o)
                    </p>
                </div>

                {/* Apotek & Obat Card */}
                <div className="bg-white p-4 rounded-xl shadow-sm border space-y-3">
                    <div className="flex items-start gap-2">
                        <img src="/images/storefront.svg" alt="Pin Lokasi" className="w-6 h-6 mt-1" />
                        <div>
                            <p className="font-semibold text-sm">{prescriptionData?.pharmacy?.outlets?.outlet}</p>
                            <p className="text-sm text-gray-500">Apotek terdekat</p>
                        </div>
                    </div>

                    {/* List Obat */}
                    {prescriptionData?.items.map((item: any, index:number) => (
                        <div key={item.prescription_item_id} className="flex items-start justify-between mb-3">
                            <div className="flex gap-2">
                                {/* <img src="/images/obat.png" alt="Obat" className="w-10 h-10 rounded" /> */}
                                <FaCapsules className="w-6 h-6 text-teal-500" />
                                <div>
                                    <p className="text-sm font-medium">{item.drug_name.trim()} x {item.unit}</p>
                                    <p className="text-sm text-gray-500">({item.frequency_dd}x{item.quantity})</p>
                                    {item.time && (
                                    <p className="text-xs text-gray-400 italic">{item.time}</p>
                                    )}
                                </div>
                            </div>
                            <div className="flex flex-col items-end">
                                {/* <button className="mb-1">
                                    <img src="/images/trash.svg" alt="Hapus" className="w-4 h-4" />
                                </button> */}
                                <span className="text-xs text-blue-600 bg-blue-100 px-2 py-0.5 rounded-full">Ditanggung</span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pengiriman Card */}
                <div
                    className="bg-white p-4 rounded-xl shadow-sm border flex items-center justify-between"
                    onClick={() => {
                        const shipping = prescriptionData?.pharmacy?.shipping;
                        if (!Array.isArray(shipping) || shipping.length === 0) {
                            setShowPharmacyAlert(true); // 🔔 tampilkan popup styled
                            return;
                        }
                        setShowShippingModal(true);
                    }}
                >
                    <div className="flex items-start gap-2">
                        <img src="/images/frame.svg" alt="Delivery" className="w-6 h-6 mt-1" />
                        <div>
                            <p className="text-sm font-medium">
                                {shippingMethod ? `${shippingMethod} • Rp${new Intl.NumberFormat('id-ID').format(cost)}` : "Belum ada metode pengiriman"}
                            </p>
                            <p className="text-sm text-gray-500">
                                {shippingMethod
                                    ? `Estimasi Tiba: ${shippingMethod === "INSTANT" ? "±2 Jam" : "Maks 3 Hari"}`
                                    : "Silakan pilih metode pengiriman"}
                            </p>
                        </div>
                    </div>
                    <img src="/images/arrow-right.svg" alt="Chevron" className="w-4 h-4" />
                </div>

                {/* Modal Shipping */}
                {showShippingModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end">
                        <div className="bg-white w-full rounded-t-2xl p-4">
                            <div className="flex justify-center mb-4">
                                <div className="w-10 h-1 bg-gray-400 rounded-full" />
                            </div>
                            <p className="font-semibold text-base mb-4">Metode Pengiriman</p>

                            {Array.isArray(prescriptionData?.pharmacy?.shipping) &&
                            prescriptionData?.pharmacy?.shipping.length > 0 ? (
                                prescriptionData.pharmacy.shipping.map((option: any) => {
                                    const totalBiaya = option?.fee_service + option?.shipping_cost;

                                    let estimasi = "-";
                                    if (option?.shipping_method?.toUpperCase() === "REGULER") {
                                        estimasi = "Estimasi Tiba: Maks 3 Hari";
                                    } else if (option?.shipping_method?.toUpperCase() === "INSTANT") {
                                        estimasi = "Estimasi Tiba: ±2 Jam";
                                    }

                                    return (
                                        <div
                                            key={option.type}
                                            onClick={() => {
                                                setShippingCost(option?.shipping_cost);
                                                setFeeService(option?.fee_service);
                                                setShippingMethod(option?.shipping_method);
                                                setShowShippingModal(false);
                                            }}
                                            className="py-3 border-t last:border-b border-gray-200 cursor-pointer hover:bg-gray-50"
                                        >
                                            <p className="text-sm font-medium">
                                                {option?.shipping_method} • Rp{new Intl.NumberFormat('id-ID').format(totalBiaya)}
                                            </p>
                                            <p className="text-sm text-gray-500">{estimasi}</p>
                                        </div>
                                    );
                                })
                            ) : (
                                <p className="text-center text-gray-500 text-sm">
                                    Tidak ada metode pengiriman tersedia.
                                </p>
                            )}

                            <button
                                onClick={() => setShowShippingModal(false)}
                                className="mt-4 w-full text-center text-sm text-blue-600"
                            >
                                Tutup
                            </button>
                        </div>
                    </div>
                )}

                {/* Modal Alert Apotek Tidak Tersedia */}
                {showPharmacyAlert && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                        <div className="bg-white rounded-2xl shadow-xl w-80 p-6 text-center animate-fade-in">
                            {/* <div className="flex justify-center mb-3">
                                <img src="/images/warning.svg" alt="Warning" className="w-10 h-10" />
                            </div> */}
                            <h2 className="text-lg font-semibold text-gray-800 mb-2">
                                Apotek/Obat tidak tersedia
                            </h2>
                            <p className="text-sm text-gray-600 mb-5">
                                Silakan tebus obat secara offline di apotek rekanan terdekat.
                            </p>
                            <button
                                onClick={() => setShowPharmacyAlert(false)}
                                className="w-full py-2 bg-red-600 text-white rounded-full font-medium hover:bg-blue-700 transition"
                            >
                                OK
                            </button>
                        </div>
                    </div>
                )}


                {/* Metode Pembayaran Card */}
                <PaymentMethods paymentMethods={paymentMethod} onSelect={handlePaymentSelect}/>

                {/* Detail Transaksi Card */}
                <div className="bg-white p-4 rounded-xl shadow-sm border space-y-2">
                    <div className="flex justify-between text-sm">
                        <span>Biaya Obat</span>
                        <span className="text-blue-600 text-sm bg-blue-100 px-2 py-0.5 rounded-full">Ditanggung</span>
                    </div>
                    <div className="flex justify-between text-sm">
                        <span>Biaya Pengiriman</span>
                        <span>Rp{new Intl.NumberFormat('id-ID').format(cost)}</span>
                    </div>
                    { totalPrice > 0 && (<>
                    <div className="flex justify-between text-sm">
                        <span>Potongan Ongkos Kirim</span>
                        <span>-Rp{new Intl.NumberFormat('id-ID').format(shippingDiscount)}</span>
                    </div>
                    <div className="border-t border-dashed border-gray-300 my-4" />
                    <div className="flex justify-between text-sm font-semibold text-red-600">
                        <span>Total</span>
                        <span>Rp{new Intl.NumberFormat('id-ID').format(totalPrice)}</span>
                    </div>
                    </>)}
                </div>
                {showPaymentModal && prescriptionData?.transaction && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end">
                        <div className="bg-white w-full rounded-t-2xl p-4">
                            <div className="flex justify-center mb-4">
                                <div className="w-10 h-1 bg-gray-400 rounded-full" />
                            </div>
                            <p className="font-semibold text-base mb-4 text-center">Akun Pembayaran</p>

                            {(() => {
                                const trx = prescriptionData.transaction;
                                const expiredUtc = new Date(trx.expired_date + 'Z');
                                const isExpired = new Date() > expiredUtc;
                                const isPaid = trx.status_payment === 'payment';

                                return (
                                    <>
                                        {/* Bank + logo */}
                                        <div className="flex items-center mb-3">
                                            <img
                                                src={trx.image}
                                                alt="Bank Logo"
                                                className="w-8 h-4 mr-3 rounded"
                                            />
                                            <div className="text-sm font-medium">{trx.bank}</div>
                                        </div>

                                        {/* VA + Copy (if not expired or paid) */}
                                        {trx?.bank?.toUpperCase() !== 'Qris' && trx?.va && (
                                            <div className="flex items-center justify-between border px-4 py-2 rounded-lg bg-gray-100 mb-4">
                                                <span className="font-mono text-lg text-gray-800">
                                                    {trx.va}
                                                </span>
                                                {!isExpired && !isPaid && (
                                                    <button
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(trx.va);
                                                            alert('Nomor VA berhasil disalin!');
                                                        }}
                                                        className="text-blue-600 hover:text-blue-800"
                                                        title="Salin nomor VA"
                                                    >
                                                        <FiCopy size={20} />
                                                    </button>
                                                )}
                                            </div>
                                        )}

                                        {/* Status */}
                                        {isPaid ? (
                                            <div className="text-sm text-center text-green-600 font-semibold mb-4">
                                                ✅ Pembayaran telah berhasil diterima.
                                            </div>
                                        ) : isExpired ? (
                                            <div className="text-sm text-center text-red-600 font-semibold mb-4">
                                                ❌ Waktu pembayaran telah berakhir. Silakan buat ulang pembayaran.
                                            </div>
                                        ) : (
                                            <div className="text-sm text-center text-gray-600 font-medium mb-4">
                                                Berlaku hingga: {expiredUtc.toLocaleString()}
                                            </div>
                                        )}

                                        {/* Tombol aksi */}
                                        {isPaid ? (
                                            <button
                                                className="block w-full bg-green-400 text-white py-2 text-center rounded-full font-semibold cursor-default"
                                                onClick={() => {
                                                    handleCloseDialog();
                                                }}
                                            >
                                                Pembayaran Selesai
                                            </button>
                                        ) : !isExpired && trx.url_payment ? (
                                            <button
                                                onClick={handleLanjutPembayaran}
                                                disabled={redirecting}
                                                className="block w-full bg-red-500 text-white py-2 text-center rounded-full font-semibold"
                                            >
                                                {redirecting ? "Mengalihkan..." : "Lanjut ke Pembayaran"}
                                            </button>

                                        ) : (
                                            <button
                                                onClick={() => {
                                                    setShowPaymentModal(false);
                                                    // Trigger buat ulang pembayaran bisa ditambahkan di sini
                                                }}
                                                className="block w-full bg-red-400 text-white py-2 text-center rounded-full font-semibold"
                                            >
                                                Buat Pembayaran Ulang
                                            </button>
                                        )}
                                    </>
                                );
                            })()}

                            <button
                                onClick={() => {setShowPaymentModal(false);handleCloseDialog();}}
                                className="mt-4 w-full text-center text-sm text-blue-600"
                            >
                                Tutup
                            </button>
                        </div>
                    </div>
                )}
                {showRedeemInfoModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-end">
                        <div className="bg-white w-full rounded-t-2xl p-6">
                        {/* Garis indikator */}
                        <div className="flex justify-center mb-4">
                            <div className="w-12 h-1 bg-gray-300 rounded-full" />
                        </div>

                        {/* Judul */}
                        <p className="font-semibold text-base mb-2 text-center text-gray-800">
                            Resep Telah Ditebus
                        </p>

                        {/* Deskripsi */}
                        <p className="text-sm text-center text-gray-600 mb-6">
                            Resep ini sudah diunduh dan tidak dapat ditebus ulang.
                            Jika Anda membutuhkan resep baru, silakan hubungi dokter Anda.
                        </p>

                        {/* Tombol Tutup */}
                        <button
                            onClick={() => { setShowRedeemInfoModal(false);handleCloseDialog();}}
                            className="block w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded-full font-semibold transition-colors"
                        >
                            Mengerti
                        </button>
                        </div>
                    </div>
                )}
            </div>
            {prescriptionData?.transaction?.status_payment === 'payment' || prescriptionData?.prescription?.is_download ? (
                ''
            ): (
                <BtmButton
                    disabled={!formReady || loading}
                    onClick={handleConfirmation}
                    label={loading ? "Memproses..." : "Konfirmasi"}
                />
            )}
        </div>
    );
};

export default CheckOutPage;